import {createAction, props} from '@ngrx/store';

import {LoadingState} from './loading-state.model';


export const setLoadingState = createAction(
  '[LoadingState/API] Set LoadingState ',
  props<{ loadingState: LoadingState }>()
);

export const deleteLoadingState = createAction(
  '[LoadingState/API] Delete LoadingState ',
  props<{ id: string }>()
);

export const clearLoadingStates = createAction(
  '[LoadingState/API] Clear LoadingStates'
);
